import { render } from "./Survey.vue?vue&type=template&id=b73a85b0&scoped=true"
import script from "./Survey.vue?vue&type=script&lang=js"
export * from "./Survey.vue?vue&type=script&lang=js"

import "./Survey.vue?vue&type=style&index=0&id=b73a85b0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b73a85b0"]])

export default __exports__